import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import AssetGroupForm from './components/asset-group-form/AssetGroupForm';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { ModelName } from '@casops/store/api';
import { useModelFormTitle } from '@casops/components/layout/model-form/useModelFormTitle';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useGetAssetGroupQuery } from '@casops/store/apis/assetGroupsApi';

const modelName = ModelName.AssetGroup;

export function ManageAssetGroup(): ReactElement {
  const title = useModelFormTitle(modelName);

  const { isLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetAssetGroupQuery,
  });

  // The renderKey must update whenever the item data changes to ensure the form is remounted and RHK and VDS stay in sync.
  const renderKey = useRenderKey(item ? item : 'create-form');

  return (
    <DrawerPanel isLoaded={isLoaded} header={title}>
      <AssetGroupForm key={renderKey} item={item} />
    </DrawerPanel>
  );
}

export default ManageAssetGroup;
